<div class="intradays-container">
    <!-- generic component DayOfWeek -->
    <cv-generic-dow-selector 
        [selectedDaysOfWeek]="rule.ActiveDays" 
        (selectedDaysOfWeekChange)="selectedDays($event)"
        [textSection]="'Games'"
        [textTitle]="'Select_Days_Used'"
        >
    </cv-generic-dow-selector>

    <!-- time support component -->

</div>